import { render, staticRenderFns } from "./MedicineReportPresent.vue?vue&type=template&id=68e4442e"
import script from "./MedicineReportPresent.vue?vue&type=script&lang=js"
export * from "./MedicineReportPresent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports